import { ShieldCheck, Users, Zap, Globe } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="font-inter text-slate-800">
      <section className="relative overflow-hidden bg-slate-950 py-20 text-white md:py-24">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(37,99,235,0.35),_transparent_35%),radial-gradient(circle_at_bottom_right,_rgba(250,204,21,0.18),_transparent_30%)]" />
        <div className="relative max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">About MekPay</h1>
          <p className="text-lg md:text-xl text-slate-200 max-w-3xl mx-auto">
            We help people and businesses move money with confidence across payments, transfers, and digital assets.
          </p>
          <p className="mt-4 text-sm md:text-base text-slate-300 max-w-3xl mx-auto">
            MekPay operates under MekBridge LTD. (RC No. 8923599), a fully registered Nigerian entity based in Lagos, Nigeria.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          <div className="rounded-[2rem] border border-slate-200 bg-slate-50 p-8">
            <h2 className="text-3xl font-bold mb-4 text-slate-900">Our Mission</h2>
            <p className="text-slate-600 leading-relaxed">
              At <span className="font-semibold text-slate-900">MekPay</span>, our mission is to make everyday financial services simple,
              secure, and accessible. From wallet funding to bill payments and transfers, we focus on delivering a smooth experience
              people can trust.
            </p>
          </div>
          <div className="rounded-[2rem] border border-slate-200 bg-slate-50 p-8">
            <h2 className="text-3xl font-bold mb-4 text-slate-900">Our Vision</h2>
            <p className="text-slate-600 leading-relaxed">
              We envision a future where modern financial tools are available to everyone in Africa, without complexity.
              MekPay is building one reliable platform for payments, banking services, and digital asset access.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-12 text-slate-900">Our Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white border border-slate-200 rounded-[2rem] p-8">
              <ShieldCheck className="mx-auto text-primary mb-4" size={40} />
              <h3 className="text-xl font-semibold mb-2">Security</h3>
              <p className="text-slate-600">We protect accounts and transactions with practical security controls and active monitoring.</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-[2rem] p-8">
              <Zap className="mx-auto text-primary mb-4" size={40} />
              <h3 className="text-xl font-semibold mb-2">Speed</h3>
              <p className="text-slate-600">Our goal is fast, dependable service so your payments and transfers happen on time.</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-[2rem] p-8">
              <Users className="mx-auto text-primary mb-4" size={40} />
              <h3 className="text-xl font-semibold mb-2">Trust</h3>
              <p className="text-slate-600">We value transparency, clear communication, and responsive support.</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-[2rem] p-8">
              <Globe className="mx-auto text-primary mb-4" size={40} />
              <h3 className="text-xl font-semibold mb-2">Innovation</h3>
              <p className="text-slate-600">We continuously improve our platform to meet changing user and business needs.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-12 text-slate-900">Why Trust MekPay?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-slate-50 border border-slate-200 rounded-[2rem] p-8">
              <h3 className="text-4xl font-bold text-primary mb-2">50K+</h3>
              <p className="text-slate-600">Users Across Growing Markets</p>
            </div>
            <div className="bg-slate-50 border border-slate-200 rounded-[2rem] p-8">
              <h3 className="text-4xl font-bold text-primary mb-2">₦500M+</h3>
              <p className="text-slate-600">Transaction Volume Processed</p>
            </div>
            <div className="bg-slate-50 border border-slate-200 rounded-[2rem] p-8">
              <h3 className="text-4xl font-bold text-primary mb-2">99.9%</h3>
              <p className="text-slate-600">Service Uptime Target</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="mx-auto max-w-4xl rounded-[2.5rem] bg-slate-950 px-8 py-12 text-center text-white shadow-2xl shadow-slate-300/40 md:px-14">
          <h2 className="text-3xl font-bold mb-6">More Than a Wallet</h2>
          <p className="text-lg text-slate-300">
            MekPay brings payments, transfers, and digital asset services together in one trusted experience.
            Whether you are an individual user, a growing business, or an enterprise team, we are here to help you move and manage money with confidence.
          </p>
        </div>
      </section>
    </div>
  );
}
